var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_853_9459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16826 4.99999L0.172495 1.00423C-0.0574989 0.774235 -0.0574989 0.402488 0.172495 0.172495C0.402488 -0.0574983 0.774236 -0.0574983 1.00423 0.172495L4.99999 4.16826L8.99577 0.172495C9.22576 -0.0574983 9.59751 -0.0574983 9.82751 0.172495C10.0575 0.402488 10.0575 0.774235 9.82751 1.00423L5.83174 4.99999L9.82751 8.99575C10.0575 9.22575 10.0575 9.59749 9.82751 9.82749C9.7128 9.94219 9.56222 9.99982 9.41164 9.99982C9.26106 9.99982 9.11048 9.94217 8.99577 9.82749L5.00001 5.83172L1.00425 9.82749C0.889544 9.94219 0.738962 9.99982 0.588381 9.99982C0.437799 9.99982 0.287218 9.94217 0.172514 9.82749C-0.0574789 9.59749 -0.0574789 9.22575 0.172514 8.99575L4.16826 4.99999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_853_9459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 10 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/XMark.204cdd928f3c4dc60313630eb1df478e.svg";
export { ForwardRef as ReactComponent };